/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Stock_No_DiscountInputs */

const vi_product_stock_no_discount = /** @type {(inputs: Product_Stock_No_DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không CK`)
};

/**

* @param {Product_Stock_No_DiscountInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_stock_no_discount = /** @type {((inputs?: Product_Stock_No_DiscountInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Stock_No_DiscountInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_stock_no_discount(inputs)
});